import { Component, OnInit, Input } from '@angular/core';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { DispatchSummary } from '../../shared/models/DispatchSummary';

@Component({
  selector: 'dispatch-status',
  templateUrl: './dispatch-status.component.html',
  styleUrls: ['./dispatch-status.component.scss']
})
export class DispatchStatusComponent implements OnInit {

  constructor() { }
  @Input() data: DispatchSummary;
  ngOnInit() {
  }

}
